import React from "react";
import "./App.css";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { AppProvider } from "./store/AppContext";
import { AdminJobsProvider } from "./contexts/AdminJobsContext";
import { ToastProvider } from "./contexts/ToastContext";
import AnalyticsTracker from "./components/AnalyticsTracker";
import HealthPinger from "./components/HealthPinger";

// Admin Layout và các trang liên quan
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminNotifications from "./pages/admin/AdminNotifications";
import AdminAudit from "./pages/admin/AdminAudit";
import AdminLocations from "./pages/admin/AdminLocations";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminUsers from "./pages/admin/AdminUsers";
import RequirePerm from "./pages/admin/RequirePerm";
import AdminSettingsLayout from "./pages/admin/settings/AdminSettingsLayout";
import AdminSettingsGlobal from "./pages/admin/settings/AdminSettingsGlobal";
import AdminSettingsAbout from "./pages/admin/settings/AdminSettingsAbout";
import AdminMedia from "./pages/admin/AdminMedia";

// Các trang public
import Home from "./pages/Home";
import LocationDetailPage from "./pages/LocationDetailPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import AccountLayout from "./layouts/AccountLayout";
import Account from "./pages/Account";
import LocationsPage from "./pages/LocationsPage";
import SharedFavoritesPage from "./pages/SharedFavoritesPage";
import About from "./pages/About";
import MapPage from "./pages/MapPage";
import NotFound from "./pages/NotFound";

function LegacyDanhMucRedirect() {
  const { categorySlug } = useParams();
  const s = String(categorySlug ?? "").trim();
  const search = s ? `?category=${encodeURIComponent(s)}` : "";

  return <Navigate to={`/locations${search}`} replace />;
}

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <AppProvider>
          <AdminJobsProvider>
            <HealthPinger />
            <AnalyticsTracker />

            <Routes>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="overview" element={<AdminOverview />} />
                <Route path="notifications" element={<AdminNotifications />} />
                <Route path="audit" element={<RequirePerm perm="audit:read"><AdminAudit /></RequirePerm>} />
                <Route path="locations" element={<AdminLocations />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="users" element={<RequirePerm perm="users:manage"><AdminUsers /></RequirePerm>} />
                <Route path="media" element={<AdminMedia />} />

                <Route path="settings" element={<AdminSettingsLayout />}>
                  <Route index element={<Navigate to="global" replace />} />
                  <Route path="global" element={<AdminSettingsGlobal />} />
                  <Route path="about" element={<AdminSettingsAbout />} />
                </Route>

                <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
              </Route>

              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              <Route path="/tai-khoan" element={<AccountLayout />}>
                <Route index element={<Account />} />
                <Route
                  path="mat-khau"
                  element={<Navigate to="/tai-khoan#doi-mat-khau" replace />}
                />
              </Route>

              <Route path="/map" element={<MapPage />} />
              <Route path="/ban-do" element={<Navigate to="/map" replace />} />

              <Route path="/locations" element={<LocationsPage />} />
              <Route
                path="/danh-muc/:categorySlug"
                element={<LegacyDanhMucRedirect />}
              />

              <Route
                path="/share/favorites/:code"
                element={<SharedFavoritesPage />}
              />

              <Route path="/areas" element={<Navigate to="/locations" replace />} />
              <Route path="/areas/:slug" element={<Navigate to="/locations" replace />} />

              <Route path="/location/:locationSlug" element={<LocationDetailPage />} />
              <Route
                path="/location/:categorySlug/:locationSlug"
                element={<LocationDetailPage />}
              />

              <Route path="/dia-diem" element={<Navigate to="/locations" replace />} />
              <Route path="/khu-vuc" element={<Navigate to="/locations" replace />} />
              <Route path="/khu-vuc/:slug" element={<Navigate to="/locations" replace />} />

              <Route path="/__preview/about" element={<About />} />

              <Route path="/ve-chung-toi" element={<Navigate to="/" replace />} />
              <Route path="/about-us" element={<Navigate to="/" replace />} />
              <Route path="/lien-he" element={<Navigate to="/" replace />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </AdminJobsProvider>
        </AppProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;